import { AfterViewChecked, AfterViewInit, Component, OnInit, QueryList, ViewChild, ViewChildren, OnDestroy } from '@angular/core';
import * as Constants from "../../../../constants/constants";
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/services/api/api.service';
import { TabControlService } from 'src/app/services/tab-control.service';
import { NotificationService } from 'src/app/services/notification.service';
import { ValidationService } from 'src/app/services/validators/validation.service';
import { environment } from 'src/environments/environment';
import { EstateControlService } from 'src/app/services/estate-control.service';
import { calculateVAT, decodeSessionData, delay, generateRandomNumber5, getValueByIdOrDescription, SessionData } from 'src/app/util/Helper';
import { debounceTime, distinctUntilChanged, Subscription, timer } from 'rxjs';
import { RadiosComponent } from 'src/app/components/radios/radios.component';
import { CardsComponent } from 'src/app/components/cards/cards.component';

@Component({
  selector: 'app-step2-payment-estate',
  templateUrl: './step2-payment-estate.component.html',
  styleUrls: ['./step2-payment-estate.component.scss']
})
export class Step2PaymentEstateComponent implements OnInit, AfterViewChecked, AfterViewInit, OnDestroy {
  @ViewChild('cardsComponent') cardsChild!: CardsComponent;
  
  private readonly subscription: Subscription = new Subscription();
  private readonly abortController = new AbortController();
  @ViewChildren(RadiosComponent) radiosComponents!: QueryList<RadiosComponent>;  // ViewChild to get reference to child
  
  session: string = ""; // used to resume session
  sessionData: SessionData | string = "error";
  
  title: string = 'Make Payment';
  subtitle: string = 'To create your Trust, please pay the amount below through either a Bank Transfer (RTGS) or M-PESA';
  paymentTitle: string = 'Payment';

  trustLabel: string = 'Trust Name';
  trustHint: string = 'Specify a name for your trust';

  trustDetailsTitle: string = 'Trust Details';
  referreLabel: string = 'Who Introduced you to Milele Trust';
  referreeOtherHint: string = 'Please tell us more';
  referreeOtherLabel: string = 'Other source';
  agentLabel: string = 'Name of Agent';
  agentHint: string = 'Enter Name';
  selectText: string = 'Select one';
  refValue: string = '';

  paymentDetailsTitle: string = 'Payment Details';
  makePaymentOption: string = 'Please select if you would like to pay the full amount or in instalments';
  instalmenPaymentsTitle: string = 'Instalment Payments';
  instalmenPaymentOption: string = 'Select the instalment option that is preferrable to you';

  paymentModeLabel: string = 'Preferred Mode of Payment';
  phoneLabel: string = 'M-Pesa Phone Number';

  bankLabel: string = 'Bank Name';
  bankHint: string = 'Select Bank';

  bankBranchLabel: string = 'Bank Branch';
  bankBranchHint: string = 'Select Bank Branch';

  accNameLabel: string = 'Account Name';
  accNameHint: string = 'Enter Account Name';

  accLabel: string = 'Account Number';
  accHint: string = 'Enter Account Number';

  receiptLabel: string = 'Existing M-PESA Receipt (Optional)';
  receiptHint: string = 'Confirm using M-Pesa Transaction Receipt if available';

  uploadSlipLabel: string = 'Upload Bank Slip/Remittance Advice';

  instructionsTitle: string = 'M-Pesa Express Payment Instructions';
  instructionsTitle2: string = 'M-Pesa Paybill Payment Instructions';

  instructionsTitleBank: string = 'ICEA LION Trust Co. Bank Deposit/Transfer Details';
  inst1: string = 'Enter your phone number and the amount you wish to pay';
  inst2: string = 'You will receive a Popup from M-Pesa on your Phone';
  inst2X: string = 'Enter your M-Pesa PIN to complete the payment on your Phone';
  inst3: string = 'You will receive a notification on your email once your transaction is complete';
  
  inst4: string = 'Go to Lipa Na M-Pesa Menu on your Phone';
  inst5: string = 'Use Paybill Business number: ';
  inst6: string = 'Use Account number: ';
  inst8: string = 'Pay and wait at least 2 minutes for the Payment to be detected and confirmed automatically';

  iceaFundLabel: string = 'Fund';
  iceaAcc: string = 'Account Number';
  iceaBank: string = 'Bank';
  iceaBranch: string = 'Branch';
  iceaBankCode: string = 'Bank Code';
  iceaBranchCode: string = 'Branch Code';
  iceaClearing: string = 'Clearing';

  fullPaymentAmountHint: string = '10% Discount applied';
  amountHint: string = this.fullPaymentAmountHint;

  iceaFundNameVal  : string = Constants.ICEA_ESTATE_NAME;
  iceaAccountVal : string = Constants.ESTATE_ACCOUNT_NUM;
  iceaBankVal : string = Constants.ICEA_BANK_ESTATE;
  iceaBranchVal : string = Constants.ICEA_BANK_BRANCH_ESTATE;
  iceaBankCodeVal : string = Constants.ESTATE_BANK_CODE;
  iceaBranchCodeVal : string = Constants.ESTATE_BRANCH_CODE;
  iceaClearingVal : string = Constants.ESTATE_CLEARING;
  iceaPaybill : number = Constants.PAYBILL_ESTATE;

  requiredFieldString: string = 'Required field';

  PaymentModeOptions: any = [
    'M-Pesa Express (STK Push)',
    'M-Pesa Paybill',
    'Cash Deposits/Bank Transfer',
    // 'Direct Card Payment'
  ];
  FilteredPaymentModeOptions: any = [...this.PaymentModeOptions];
  BranchPlaceHolders: any = [];

  payFullAmount: boolean | null = null;
  pay50Instalment: boolean | null = null;
  loadingBanks: boolean = false;
  loadingBankBranches: boolean = false;

  banksEmpty: boolean = true;
  bankBranchesEmpty: boolean = true;

  trustFee: number = Constants.TRUST_CREATION_FEE;
  legalReviewFee: number = Constants.LEGAL_REVIEW_FEE;
  taxConsFee: number = Constants.TAX_CONSULTATION_FEE;
  investmentConsFee: number = Constants.INVESTMENT_CONSULTATION_FEE;

  plusLegal = new FormControl(false);
  plusTax = new FormControl(false);
  plusInvestment = new FormControl(false);

  totalAmount: number = this.trustFee;
  
  paymentAmount: number = this.totalAmount;
  
  randomSuffix: number = generateRandomNumber5();
  trustName: string = 'TrustName';
  ccEmails: any = [];

  private hasInitialized: boolean = false;

  countdownMPESA: number = 180;
  private timerSubscription: Subscription | null = null;


  formErrors: { [key: string]: string } = {
    PaymentMode: '',
    trustName: '',
    amount: '',
    phone: '',
    bank: '',
    bankBranch: '',
    accName: '',
    acc: '',
    slipDoc: '',
    email: '',
    receipt: '',
    
    referree: '',
    referreeName: '',
    other: ''
  };
  validationMessages: { [key: string]: {} } = {
    PaymentMode: { required: this.requiredFieldString },
    trustName: { required: this.requiredFieldString },
    phone: { required: this.requiredFieldString, invalid:'Invalid phone number' },
    bank: { required: this.requiredFieldString },
    bankBranch: { required: this.requiredFieldString },
    accName: { required: this.requiredFieldString },
    acc: { required: this.requiredFieldString },
    slipDoc: { required: this.requiredFieldString },
    email: { required: this.requiredFieldString, email: "Invalid email address" },
    receipt: { required: this.requiredFieldString },

    referree: { required: this.requiredFieldString },
    referreeName: { required: this.requiredFieldString },
    other: { required: this.requiredFieldString }
  };


  // Form
  paymentForm = this._formBuilder.group({
    PaymentMode: [this.PaymentModeOptions[0], Validators.required],
    trustName: ['', Validators.required],
    phone: ['', Validators.required],
    
    bank: [{value: '', disabled: true}],
    bankBranch: [{value: '', disabled: true}],
    accName: [''],
    acc: [''],
    slipDoc: [],

    referree: [``, Validators.required],
    referreeName: [``],
    other: [``],

    receipt: [''],

    // Card controls
    Currency: [''],
    CardNumber: [''],
    CVV: [''],
    Expiry: [''],
    CardName : ['']
  });

  constructor(
    private readonly _formBuilder: FormBuilder,
    private readonly validationService: ValidationService,
    private readonly apiService: ApiService,
    private readonly notificationService: NotificationService,
    private readonly tabControlService: TabControlService,
    public estateControlService: EstateControlService,
    private readonly route: ActivatedRoute,
    private readonly router: Router
  ) {
    this.plusLegal.valueChanges.subscribe((value)=> {
      if (this.plusLegal.enabled) {
        if (value) {
          this.totalAmount += this.legalReviewFee;
        } else {
          this.totalAmount -= this.legalReviewFee;
        }
        this.updatePaymentAmount();
      }
    });

    this.plusTax.valueChanges.subscribe((value)=> {
      if (this.plusTax.enabled) {
        if (value) {
          this.totalAmount += this.taxConsFee;
        } else {
          this.totalAmount -= this.taxConsFee;
        }
        this.updatePaymentAmount();
      }
    });

    this.plusInvestment.valueChanges.subscribe((value)=> {
      if (this.plusInvestment.enabled) {
        if (value) {
          this.totalAmount += this.investmentConsFee;
        } else {
          this.totalAmount -= this.investmentConsFee;
        }
        this.updatePaymentAmount();
      }
    });
  }


  ngOnInit(): void {
    if (this.BanksOptions.length == 0) this.getBanksList();

    if (this.settlors && this.settlors.length > 0) {
      for (let i=1; i<this.settlors.length; i++) {
        const item = {
          FirstName: this.settlors[i].FirstName,
          Email: this.settlors[i].Email,
          Phone: this.settlors[i].Phone
        };
        this.ccEmails.push(item);
      } 
    }

    this.route.queryParams.subscribe((params) => {
      if (params["session"] != undefined) {
        this.session = params["session"];
        const sessionData = decodeSessionData(this.session);

        if (this.isSessionData(sessionData) && sessionData.Referree) {
          this.sessionData = sessionData;
          if (sessionData.Referree.Type && sessionData.Referree.Code) {
            if (this.paymentForm) {
              if (sessionData.Referree.Type == 'agent') {
                this.refValue = this.HearAboutusData[2];

              } else if (sessionData.Referree.Type == 'fubro') {
                  this.refValue = this.HearAboutusData[3];

              } else if (sessionData.Referree.Type == 'tla') {
                this.refValue = this.HearAboutusData[1];

              } else if (sessionData.Referree.Type == 'con') {
                this.refValue = this.HearAboutusData[0];
              }

              this.paymentForm.get('referree')?.setValue(this.refValue);
              this.checkIntermediary();
            }
            this.notificationService.viewToast('info', 'Referral details updated'); 
          }
        }
      }

      // Handle cards
      const intentId = params['intentId'];
      const action = params['action'];
      
      if (intentId && action?.toLowerCase() === 'make_payment') {
        // Helper to remove intentId & action params while keeping all others (like session)
        const clearPaymentParams = () => {
          this.router.navigate([], {
            relativeTo: this.route,
            queryParams: {
              intentId: null,
              action: null
            },
            queryParamsHandling: 'merge'
          });
        };

        // Check if the payment has already been marked complete beforehand
        if (this.payment?.done) {
          clearPaymentParams();
        } else {
          // Force the layout context to reflect Direct Card Payment mode
          this.paymentForm.get('PaymentMode')?.setValue(this.PaymentModeOptions[3]);
          
          // Run validation check specifically for the card section inputs
          const cardControls = ['Currency', 'CardNumber', 'CVV', 'Expiry', 'CardName'];
          let isCardFormValid = true;

          cardControls.forEach(controlName => {
            const control = this.paymentForm.get(controlName);
            if (control) {
              control.updateValueAndValidity();
              if (control.invalid) {
                isCardFormValid = false;
              }
            }
          });
          if (isCardFormValid) {
            this.notificationService.isLoading(true);
            this.notificationService.viewToast('info', 'Processing card payment...');

            // Update the payment tracking state internally beforehand
            this.estateControlService.stkRequestID = intentId;

            // Directly ping the process payment endpoint using the returned reference identifier
            this.apiService.getRequest(`${environment.baseUrl}${Constants.processCardPaymentURL}?ref=${intentId}`)
              .then(async (response: any) => {
                if (response.Status === 1 && response.Data?.status === 'COMPLETED') {
                  this.notificationService.viewToast('success', 'Card payment received');
                  
                  // Finalize locally saved storage definitions
                  const object = {...this.paymentForm.value, mode: 'CARD'};
                  await this.estateControlService.updateRecordWill(2, object);
                  
                  // Commit updates to server configuration mappings
                  await this.updateTrustDetails('CARD');
                  // Strip parameters now that the processing cycle is complete
                  clearPaymentParams();
                } else {
                  this.notificationService.viewToast('error', 'Payment confirmation failed', response.Message || 'Please try again.');
                  this.notificationService.isLoading(false);
                }
              })
              .catch((error: any) => {
                console.error('Failed to process redirected card payment:', error);
                this.notificationService.viewToast('error', 'An error occurred', 'Could not complete payment verification');
                this.notificationService.isLoading(false);
              });
          } else {
            this.notificationService.viewToast('warning', 'Card parameters are invalid or missing from session cache.');
            this.logErrors();
          }
        }
      }
    });

    if (this.payment.plusLegal) this.plusLegal.setValue(this.payment.plusLegal);
    if (this.payment.plusTax) this.plusTax.setValue(this.payment.plusTax);
    if (this.payment.plusInvestment) this.plusInvestment.setValue(this.payment.plusInvestment);

    // Resume page
    if (Object.keys(this.payment).length > 5 && this.paymentForm) {
      this.paymentForm = this._formBuilder.group({
        PaymentMode: [this.payment.PaymentMode || this.PaymentModeOptions[0], Validators.required],

        trustName: [`${this.payment.trustName || ''}`, Validators.required],
        phone: [this.payment.phone || '', Validators.required],
        bank: [{value: '', disabled: true}],
        bankBranch: [{value: '', disabled: true}],
        accName: [this.payment.accName || ''],
        acc: [this.payment.acc || ''],
        slipDoc: [],

        referree: [this.payment.referree || '', Validators.required],
        referreeName: [this.payment.referreeName || ''],
        other: [this.payment.other || ''],

        receipt: [''],
        // Card controls
        Currency: [''],
        CardNumber: [''],
        CVV: [''],
        Expiry: [''],
        CardName : ['']
      });
    }

    if (this.estateControlService.paymentID == '') {
      this.estateControlService.paymentID = `PRV-${this.settlors[0].IDNo}-${this.randomSuffix}`.toLowerCase();
      this.estateControlService.updateStorageObject();
    } else {
      const splitID: any[] = this.estateControlService.paymentID.split('-');
      this.randomSuffix = Number(splitID.at(-1));
    }

    this.subscription.add(
      this.estateControlService.updateTrustDetails$.subscribe(paymentMode => {
        this.updateTrustDetails(paymentMode);
      })
    );

    this.paymentForm.get('PaymentMode')?.valueChanges.subscribe((data) => {
      if (data === this.PaymentModeOptions[3]) { // Card
        this.validationService.addOrRemoveValidator(true, this.paymentForm.get('Currency')!);
        this.validationService.addOrRemoveValidator(true, this.paymentForm.get('CardNumber')!);
        this.validationService.addOrRemoveValidator(true, this.paymentForm.get('CVV')!);
        this.validationService.addOrRemoveValidator(true, this.paymentForm.get('Expiry')!);
        this.validationService.addOrRemoveValidator(true, this.paymentForm.get('CardName')!);

        this.validationService.addOrRemoveValidator(false, this.paymentForm.get('phone')!);
        this.paymentForm.get('phone')?.setValue('');
        this.paymentForm.get('receipt')?.setValue('');
        this.validationService.addOrRemoveValidator(false, this.paymentForm.get('bank')!);
        this.validationService.addOrRemoveValidator(false, this.paymentForm.get('bankBranch')!);
        this.validationService.addOrRemoveValidator(false, this.paymentForm.get('accName')!);
        this.validationService.addOrRemoveValidator(false, this.paymentForm.get('acc')!);
        this.validationService.addOrRemoveValidator(false, this.paymentForm.get('slipDoc')!);

        this.paymentForm.get('bank')?.setValue('');
        this.paymentForm.get('bankBranch')?.setValue('');
        this.paymentForm.get('accName')?.setValue('');
        this.paymentForm.get('acc')?.setValue('');
        this.paymentForm.get('slipDoc')?.setValue(null);

      } else if (data === this.PaymentModeOptions[2]) { // Bank
        this.resetTimer();
        this.validationService.addOrRemoveValidator(true, this.paymentForm.get('bank')!);
        this.validationService.addOrRemoveValidator(true, this.paymentForm.get('bankBranch')!);
        this.validationService.addOrRemoveValidator(true, this.paymentForm.get('accName')!);
        this.validationService.addOrRemoveValidator(true, this.paymentForm.get('acc')!);
        this.validationService.addOrRemoveValidator(true, this.paymentForm.get('slipDoc')!);

        this.validationService.addOrRemoveValidator(false, this.paymentForm.get('phone')!);
        this.paymentForm.get('phone')?.setValue('');
        this.paymentForm.get('receipt')?.setValue('');

        if (this.BanksOptions.length === 0) this.getBanksList();
        else this.paymentForm.get('bank')?.enable()

      } else {
        this.validationService.addOrRemoveValidator(false, this.paymentForm.get('bank')!);
        this.validationService.addOrRemoveValidator(false, this.paymentForm.get('bankBranch')!);
        this.validationService.addOrRemoveValidator(false, this.paymentForm.get('accName')!);
        this.validationService.addOrRemoveValidator(false, this.paymentForm.get('acc')!);
        this.validationService.addOrRemoveValidator(false, this.paymentForm.get('slipDoc')!);

        this.paymentForm.get('bank')?.setValue('');
        this.paymentForm.get('bankBranch')?.setValue('');
        this.paymentForm.get('accName')?.setValue('');
        this.paymentForm.get('acc')?.setValue('');
        this.paymentForm.get('slipDoc')?.setValue(null);

        if (data === this.PaymentModeOptions[1]) { // M-PESA PAYBILL
          this.validationService.addOrRemoveValidator(false, this.paymentForm.get('phone')!);
          this.paymentForm.get('phone')?.setValue('');

          this.startCheckPaymentTimer();
        } else {
          this.resetTimer();
          this.paymentForm.get('receipt')?.setValue('');
          this.validationService.addOrRemoveValidator(true, this.paymentForm.get('phone')!);
        }
      }
    });

    this.paymentForm.get('referree')?.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged() // Prevent select's duplicate emissions
    ).subscribe((value) => {
      if (value) {
        if (this.session !== "") {
          try {
            const sessionData = decodeSessionData(this.session);
    
            if (this.isSessionData(sessionData) && sessionData.Referree?.Type && sessionData.Referree.Code
                && this.paymentForm.get('referree')?.value !== this.refValue) {
    
              this.paymentForm.get('referree')?.setValue(this.refValue);
              this.notificationService.viewToast('info', 'This session contains a referral from the agent');
              return; // Exit early if resetting the value
            }
          } catch (ex) {console.log('error ? ', ex)};
        }
        this.checkIntermediary();
      }
    });

    this.paymentForm.valueChanges.subscribe(()=> {
      this.logErrors();

      const object = {
        ...this.paymentForm.value,
        plusLegal: this.plusLegal.value,
        plusTax: this.plusTax.value,
        plusInvestment: this.plusInvestment.value,
        payFullAmount: this.payFullAmount,
        pay50Instalment: this.pay50Instalment
        
      };
      this.estateControlService.updateRecord(2, object);
    })
    
    this.validationService.addOrRemoveValidationOnValues(
      this.paymentForm.get("referree")!,
      "referreeName",
      this.paymentForm,
      ["Independent Agent", "Broker", "ICEA LION Financial Advisor", "ICEA LION Trust Consultant"]
    );
    this.validationService.addOrRemoveValidationOnValue(
      this.paymentForm.get("referree")!,
      "other",
      this.paymentForm,
      "Other"
    );
  }
  ngAfterViewInit(): void {
    const radiosArray = this.radiosComponents.toArray();
    radiosArray.forEach((radiosComponent, index) => {
      if (index === 0) {
        if (!(this.payment.payFullAmount == null || this.payment.payFullAmount == undefined)) {
          this.onOptionChange(this.payment.payFullAmount);
          radiosComponent.onRadioClick(this.payment.payFullAmount);  // set selectedA and emit valueChange
          this.hasInitialized = true;
        }
      }
    });
  }
  ngAfterViewChecked(): void { // Runs every time after form value changes
    const radiosArray = this.radiosComponents.toArray();    
      radiosArray.forEach((radiosComponent, index) => {
        if (index === 1) {
          if (!(this.payment.pay50Instalment == null || this.payment.pay50Instalment == undefined)) {
            this.onInstalmentChange(this.payment.pay50Instalment);
            radiosComponent.onRadioClick(this.payment.pay50Instalment);
          }
        }
      });

      if (this.payment.done) {
        this.plusLegal.disable();
        this.plusTax.disable();
        this.plusInvestment.disable();
      }
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.stopTimer();
    this.abortController.abort();
  }

  logErrors() {
    this.formErrors = this.validationService.logValidationErrors(
      this.paymentForm,
      this.formErrors,
      this.validationMessages
    );
  }

  get loading(): boolean {
    return this.notificationService.loading;
  }

  get vatAmount(): number {
    return this.apiService.vatAmount;
  }
  get settlors(): any {
    return this.estateControlService.settlors;
  }
  get payment(): any {
    return this.estateControlService.payment;
  }
  get paymentID(): string {
    return this.estateControlService.paymentID;
  }
  get stkRequestID(): string {
    return this.estateControlService.stkRequestID;
  }

  get BanksOptions(): any {
    return this.tabControlService.BanksOptions;
  }
  get HearAboutusData(): any {
    return this.tabControlService.HearAboutusData;
  }
  get loadingIntermediaries(): boolean {
    return this.tabControlService.loadingIntermediaries;
  }
  get IntermediaryOptions(): any {
    return this.tabControlService.IntermediaryOptions;
  }
  
  slipObject: any = null;

  isSessionData(obj: any): obj is SessionData {
    return (
      typeof obj === 'object'
    );
  }
  updateSlipObject(object: any): void {
    this.slipObject = object;
  }

  returnNetAmount() {
    return calculateVAT(this.vatAmount, this.totalAmount);
  }

  onOptionChange(value: boolean): void {
    this.payFullAmount = value;
    if (this.hasInitialized) this.paymentForm.reset();
    
    if (this.payFullAmount) {
      // Exclude both M-Pesa options
      this.FilteredPaymentModeOptions = this.PaymentModeOptions.filter(
        (option: string) => !option.toLowerCase().includes('m-pesa')
      );
      
      // Fallback default: 'Cash Deposits/Bank Transfer' (Index 2 in master array)
      this.paymentForm.get('PaymentMode')?.setValue(this.PaymentModeOptions[2]);
    } else {
      // Restore all options if not full payment
      this.FilteredPaymentModeOptions = [...this.PaymentModeOptions];
      
      // Fallback default: 'M-Pesa Express (STK Push)' (Index 0 in master array)
      this.paymentForm.get('PaymentMode')?.setValue(this.PaymentModeOptions[0]);
    }
    
    this.paymentForm.updateValueAndValidity();
    this.updatePaymentAmount();
  }
  onInstalmentChange(value: boolean): void {
    this.pay50Instalment = value;
    this.updateInstalmentAmount();
  }

  updatePaymentAmount(): void {
    if (this.payFullAmount) {
      this.paymentAmount = (90/100 * this.returnNetAmount());
      this.pay50Instalment = null;
      this.amountHint = this.fullPaymentAmountHint;
    } else {
      this.amountHint = '';
      this.updateInstalmentAmount();
    }
  }
  updateInstalmentAmount(): void {
    if (this.pay50Instalment) {
      this.paymentAmount = (50/100 * this.returnNetAmount());
    } else if (this.pay50Instalment === false) {
      this.paymentAmount = (30/100 * this.returnNetAmount());
    } else {
      this.paymentAmount = this.returnNetAmount();
    }
  }

  startCheckPaymentTimer(): void {
    this.resetTimer();

    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }

    this.timerSubscription = timer(0, 1000).subscribe((elapsedTime) => {
      if (this.countdownMPESA > 0) {
        this.countdownMPESA--;
      } else {
        this.timerSubscription?.unsubscribe();
        this.confirmPaybillPayment(10);
      }
    });
  }

  stopTimer(): void {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
      this.timerSubscription = null;
    }
  }

  resetTimer(): void {
    this.stopTimer();
    this.countdownMPESA = 180;
  }

  cancelApiCall() {
    // Abort the ongoing request manually
    this.abortController.abort();
    if (!environment.production) console.log('API call canceled');
  }

  async checkIntermediary(): Promise<void> {
    this.paymentForm.get('referreeName')?.setValue('');
    
    const data = this.paymentForm.get('referree')?.value;

    if (data) {
      console.log('acsac ', data)
      if (data.toLowerCase() == 'icea lion trust consultant') {
        await this.tabControlService.getConsultants();

      } else {
        if (data.toLowerCase() == 'independent agent') {
          await this.tabControlService.getIntermediaries('agent');

        } else if (data.toLowerCase() == 'broker') {
          await this.tabControlService.getIntermediaries('Fubro');
          
        } else if (data.toLowerCase() == 'icea lion financial advisor') {
          await this.tabControlService.getIntermediaries('tla');
        }
      }

      if (this.isSessionData(this.sessionData)) {
  
        if (this.sessionData.Referree) {
          if (this.sessionData.Referree.Type && this.sessionData.Referree.Code) {
  
            if (this.IntermediaryOptions.length > 0) {
              this.paymentForm.get('referreeName')?.setValue(
                getValueByIdOrDescription(this.sessionData.Referree.Code, this.IntermediaryOptions, 0)
              );
              this.paymentForm.get('referreeName')?.disable();
            }
          }
        }
      }
    }
  }
  
  async getBanksList() {
    this.loadingBanks = true;

    const response = await this.tabControlService.getBanksList();
    if (response === 1) {
      this.paymentForm.get('bank')?.enable();
      this.banksEmpty = false;
    } else {
      this.banksEmpty = true;
    }
    this.loadingBanks = false;
  }
  async populateBankBranchesList() {
    this.loadingBankBranches = true;
    this.BranchPlaceHolders = [];
    
    try {
      const bankValue = this.paymentForm.get('bank')?.value;
  
      if (!(bankValue === null || bankValue ==='' || bankValue === undefined)) {
        
        const branchRequest = {
          BankID: `${bankValue}`,
        };
        const response = await this.apiService.postRequest(
          environment.baseUrl + Constants.bankBranchesURL,
          branchRequest
        );

        if (response.Status === 1) {
          const sortedData = response.Data.sort((a: any, b: any) => {
            return a.Description.localeCompare(b.Description);
          });
          this.BranchPlaceHolders = sortedData;
          this.paymentForm.get('bankBranch')?.enable();
          this.bankBranchesEmpty = false;
        } else {
          console.log('>>> Error !! ', response.Message);
          this.bankBranchesEmpty = true;
        }
        this.loadingBankBranches = false;
      }
    } catch(error) {
      console.log('>>> Error !! ', error);
    }
    this.loadingBankBranches = false;
  }

  async confirmPaybillPayment(attempts?: number): Promise<void> {
    if (attempts == 1) this.notificationService.isLoading(true);
    this.estateControlService.updateSTK(this.paymentAmount.toString(), 'From paybill');
    
    let finalAttempts = attempts;
    if (!attempts) {
      this.notificationService.viewToast('info', 'Checking for M-Pesa Payment');
      this.notificationService.isLoading(true);
      finalAttempts = 5;
    }

    await this.retryMpesaPaymentConfirmation(finalAttempts)
    .then(async (result) => {
      this.notificationService.isLoading(false);

      if (result.Status === 1) {
        this.estateControlService.stkRequestID = result.Reference;
        this.notificationService.viewToast('info', 'Payment received');
        
        const object = {
          done: true,
          mode: 'MPESA Paybill',
        };
        
        await this.estateControlService.updateRecord(2, object);
        await this.updateTrustDetails('MPESA Paybill');
        
      } else if (result.Status === 2) {
        this.notificationService.viewToast(
          'error',
          'Could not confirm your payment', 'If you have already paid, check again using the `Confirm Payment` Button'
        );
        
      } else {
        // Error occurred!!
        this.notificationService.viewToast('error', 'Transaction not confirmed', result.Message);
      }
      
    })
    .catch((error) => {
      this.notificationService.isLoading(false);
      console.error('confirmPaybillPayment:', error);
      this.notificationService.viewToast('error', 'An unexpected error occurred');
    });
  }


  async mpesaPayment(): Promise<void> {
    if (this.paymentForm.invalid) {
      this.notificationService.viewToast('warning', 'Please fill in the payment details first');
      return;
    }

    this.notificationService.isLoading(true);
    const object = {
      ...this.paymentForm.value,
      plusLegal: this.plusLegal.value,
      plusTax: this.plusTax.value,
      plusInvestment: this.plusInvestment.value,
      payFullAmount: this.payFullAmount,
      pay50Instalment: this.pay50Instalment
      
    };
    await this.estateControlService.updateRecord(2, object);

    try {
      const data = {
        Amount: environment.production ? this.paymentAmount : '1',
        Phone: this.paymentForm.value.phone,
        BillRefNo: this.paymentID,
        TrustName: this.trustName,
        Paybill: 'estate'
      };

      const response = await this.apiService.postRequest(
        environment.baseUrl + Constants.mpesaPaymentURL, data);

      if (response.Status === 1) {
        this.notificationService.viewToast('info', 'M-Pesa Payment requested');

        if (environment.production) {
          this.estateControlService.updateSTK(this.paymentAmount.toString(), this.paymentForm.value.phone as string);
        } else {
          this.estateControlService.updateSTK('1', this.paymentForm.value.phone as string);
        }
        this.estateControlService.stkPinText = this.estateControlService.stkDefPinText;
        this.notificationService.isLoading(false);
        this.estateControlService.stkLoading = true;

        await delay(30000);

        await this.retryMpesaPaymentConfirmation()
        .then(async (result) => {
          if (result.Status === 1) {
            this.estateControlService.stkRequestID = result.Reference;

            const object = {
              done: true,
              mode: 'MPESA Express',
            };
            await this.estateControlService.updateRecord(2, object);

            this.notificationService.viewToast('info', 'Payment received');
            this.estateControlService.stkLoading = false;
            await this.updateTrustDetails('MPESA Express');
            
          } else if (result.Status === 2) {
            this.notificationService.viewToast('error', 'Could not confirm your payment');
            this.estateControlService.stkTimeout = true;
            
          } else {
            // Error occurred!!
            this.notificationService.viewToast('error', result.Message);
            this.estateControlService.stkTimeout = true;
          }
          
        })
        .catch((error) => {
          console.error('Error:', error);
          this.notificationService.viewToast('error', 'An unexpected error occurred');
        }); 
      } else {
        console.error('MpesaPayment : ', response.Message);
        this.notificationService.isLoading(false);
        this.notificationService.viewToast('error', response.Message);
      }
    } catch (error) {
      console.error('MpesaPayment ! ', error);
      this.notificationService.isLoading(false);
      this.notificationService.viewToast('error', 'An unexpected error occurred');
    }
  }
  async retryMpesaPaymentConfirmation(maxAttempts: number = 5): Promise<any> {
    let attempts = 0;

    const confirmMpesaPayment = async (): Promise<any> => {
      try {
        const receiptCode = this.paymentForm.get('receipt')?.value;
        
        if (receiptCode && receiptCode.length > 5) this.estateControlService.reqPath = Constants.MPESA_RECEIPT_PATH;
        else this.estateControlService.reqPath = Constants.MPESA_BILL_PATH;

        let phone = this.paymentForm.get('phone')?.value;
        if (phone == null || phone == undefined || phone == '') phone = this.estateControlService.settlors[0].Phone;

        const data = {
          PaymentID: this.paymentID,
          Phone:  phone,
          RequestPath: this.estateControlService.reqPath,
          BillRefNo: receiptCode && receiptCode.length > 5 ? receiptCode : this.paymentID,
        };
  
        const response = await this.apiService.postRequest(
          environment.baseUrl + Constants.confirmMPESAPaymentURL,
          data, 
          true, 
          'application/json', 
          this.abortController.signal);
  
          if (!environment.production) console.log(':::: RESPONSE !!!!\n', response);
  
        if (response?.Status) {
          return response;
        } else {
          return {
            Status: 0,
            Message: 'Error contacting server'
          };
  
        }
        
      } catch (error) {
        let resp = {
          Status: 0,
          Message: 'An unexpected error occurred'
        }
        console.log(':: Error !! ', error);
  
        return resp;
      }
    }
  
    async function tryConfirmation() {
      attempts++;
      if (!environment.production) console.log(`Attempt ${attempts}`);
  
      const response = await confirmMpesaPayment();
  
      if (response.Status === 1) {
        return response;
        
      } else if (response.Status === 2) {
        if (attempts < maxAttempts) {
          await delay(15000); // Wait for 15 seconds
          return tryConfirmation();
        } else {
          return {
            Status: 2,
            Message: 'Max retry attempts reached'
          };
        }
        
      } else {
        return {
          Status: 0,
          Message: response.Message
        };
      }
    }
  
    return tryConfirmation();
  }

  async rtgsPayment(): Promise<void> {
    const object = {
      ...this.paymentForm.value,
      mode: 'RTGS',
      plusLegal: this.plusLegal.value,
      plusTax: this.plusTax.value,
      plusInvestment: this.plusInvestment.value,
      payFullAmount: this.payFullAmount,
      pay50Instalment: this.pay50Instalment
    };
    await this.estateControlService.updateRecord(2, object);
    this.updateTrustDetails('RTGS');
  }

  // Initial trigger method called by submitForm() routing logic
  async directCardPayment(): Promise<void> {
    const object = {
      ...this.paymentForm.value,
      mode: 'CARD',
      plusLegal: this.plusLegal.value,
      plusTax: this.plusTax.value,
      plusInvestment: this.plusInvestment.value,
      payFullAmount: this.payFullAmount,
      pay50Instalment: this.pay50Instalment
    };
    // Safely cache form details beforehand
    await this.estateControlService.updateRecord(2, object);
    // Kickstart the multi-step card processing engine inside the child component
    await this.cardsChild.createPaymentIntent();
  }
  // Success Callback handler hooked to Cards child component output listener
  async onCardPaymentSuccess(): Promise<void> {
    // This runs ONLY when the transaction states turn into 'COMPLETED'
    await this.updateTrustDetails('CARD');
  }

  async updateTrustDetails(paymentMode: string): Promise<void> {
    this.notificationService.isLoading(true);
    try {
      let agentCode = '';
      let agentPhone = '';

      if (this.paymentForm.controls['referreeName'].value && this.paymentForm.controls['referreeName'].value !== '') {
        agentCode = getValueByIdOrDescription(this.paymentForm.controls['referreeName'].value, this.IntermediaryOptions, 2);
        agentPhone = getValueByIdOrDescription(this.paymentForm.controls['referreeName'].value, this.IntermediaryOptions, 1);
      }

      const data = {
        Progress: 'Payment',
        PaymentStatus: 'True',
        PaymentType: `${this.payFullAmount ? 'FullAmount' : 'Instalments'}`,
        InstalmentOptions: `${this.pay50Instalment ? '50 Perc' : '30 Perc'}`,
        
        InvestmentConsultationFee: this.investmentConsFee,
        LegalReviewFee: this.legalReviewFee,
        TaxConsultationFee: this.taxConsFee,
        TrustCreationFee: this.trustFee,
        MpesaRefNo: this.stkRequestID,
        Amount: this.paymentAmount,
        BankSlipUrl: this.slipObject,

        PaymentMode: paymentMode, // MPESA Paybill | MPESA Express | RTGS | CARD
        
        Referree: this.paymentForm.value.referree == 'Other' ? this.paymentForm.value.other : this.paymentForm.value.referree,
        AgentName: this.paymentForm.value.referreeName,
        AgentCode: agentCode,
        AgentPhoneNo: agentPhone,
        
        TrustName: this.paymentForm.value.trustName?.replace(' ', '-'),
        Phone: this.paymentForm.value.phone,
        BankName: this.paymentForm.value.bank,
        BankBranch: this.paymentForm.value.bankBranch,
        AccountName: this.paymentForm.value.accName,
        AccountNo: this.paymentForm.value.acc,
        
        CCEmails: this.ccEmails,
        Name: this.estateControlService.settlors[0].FirstName,
        Email: this.estateControlService.settlors[0].Email,
        PrimaryPhone: this.estateControlService.settlors[0].Phone,
        TrustID: this.estateControlService.TrustID,
      };

      const response = await this.apiService.postRequest(
        environment.baseUrl + Constants.privateTrustDetailsURL, data, false);
      
      if (response.Status === 1) {
        if (paymentMode == 'RTGS') {
          this.notificationService.viewToast('info', 'Payment Slip received');
          this.estateControlService.updateDocSummary(response.SlipURL);
        } else if (paymentMode == 'CARD') {
          this.notificationService.viewToast('info', 'Card payment received');
        } else {
          this.notificationService.viewToast('info', 'M-Pesa Payment received');
        }

        let object = this.payment;
        object.uploaded = true;
        object.done = true; // For RTGS
        object = {
          ...object,
          Amount: data.Amount,
          TrustName: data.TrustName,
          PaymentMode: paymentMode,
          MpesaRefNo: data.MpesaRefNo,
          InvestmentConsultationFee: this.investmentConsFee,
          LegalReviewFee: this.legalReviewFee,
          TaxConsultationFee: this.taxConsFee,
          TrustCreationFee: this.trustFee
        }
        await this.estateControlService.updateRecord(2, object);

        const extraData = {
          Persons: this.settlors,
          PaymentMode: paymentMode,
          Amount: this.paymentAmount,
          Referree: (data.AgentName && data.AgentName.length > 2 ? data.AgentName : data.Referree),
          AccountType: 'PrivateTrust',
          TrustID: this.estateControlService.TrustID
        }

        await this.estateControlService.updateConsultationData(extraData);
        this.navigateFunction();

      } else {
        this.notificationService.viewToast('error', response.Message);
      }

    } catch (error) {
      console.error(':: Error !! ', error);
      this.notificationService.viewToast('error', 'An unexpected error occurred');
    }
    this.notificationService.isLoading(false);
  }

  submitForm(): void {
    if (this.payment.done && this.payment.mode) {
      if (this.payment.uploaded) {
        this.navigateFunction();
      } else {
        this.updateTrustDetails(this.payment.mode);
      }
    } else {
      if (this.paymentForm.value.PaymentMode === this.PaymentModeOptions[0]) {
        this.mpesaPayment();
      } else if (this.paymentForm.value.PaymentMode === this.PaymentModeOptions[1]) {
        this.confirmPaybillPayment(1);
      } else if (this.paymentForm.value.PaymentMode === this.PaymentModeOptions[3]) {
        if (this.cardsChild) {
          this.directCardPayment();
        } else {
          this.notificationService.viewToast('error', 'Unable to run cards logic');
          console.error('CardsComponent is not rendered or available yet.');
        }
      } else {
        this.rtgsPayment();
      }
    }
  }

  async navigateFunction(): Promise<void> {
    await this.estateControlService.changeTab(3);
    this.estateControlService.page2Done = true;
  }
}
